module.exports = __webpack_public_path__ + "static/media/CS2 -- 7.58d31eb5.png";